if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      if (FoxTheme.config.motionReduced) return;
      this.promotion = this.querySelector('.promotion');
      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }

    connectedCallback() {
      const startTime = this.dataset.startTime;
      const endTime = this.dataset.endTime;
      const allowedDays = this.dataset.allowedDays;
      
      if (startTime && endTime) {
        const parseTime = (timeStr) => {
          const [time, modifier] = timeStr.split(' ');
          let [hours, minutes] = time.split(':').map(Number);
          if (modifier === 'PM' && hours !== 12) hours += 12;
          if (modifier === 'AM' && hours === 12) hours = 0;
          return { hours, minutes };
        };

        const parts = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Brisbane',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        }).formatToParts(new Date());
      
        const lookup = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
        const brisbaneNow = new Date(
          `${lookup.year}-${lookup.month}-${lookup.day}T${lookup.hour}:${lookup.minute}:${lookup.second}`
        );

        if (allowedDays) {
          const days = allowedDays.split(',').map(d => d.trim());
          const weekdayMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
          const today = weekdayMap[brisbaneNow.getDay()];
          if (!days.includes(today)) {
            this.remove();
            return;
          }
        }
      
        const { hours: startH, minutes: startM } = parseTime(startTime);
        const { hours: endH, minutes: endM } = parseTime(endTime);
      
        const start = new Date(brisbaneNow);
        start.setHours(startH, startM, 0, 0);
      
        const end = new Date(brisbaneNow);
        end.setHours(endH, endM, 0, 0);
      
        let inWindow = false;
        if (start < end) {
          inWindow = brisbaneNow >= start && brisbaneNow <= end;
        } else {
          inWindow = brisbaneNow >= start || brisbaneNow <= end;
        }
      
        if (!inWindow) {
          this.remove();
        } else {
          this.classList.remove('!hidden');
        }
      }
    }
    
    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.appendChild(this.clone);
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
